<div class="card border-0 marketplace-admin-card" (click)="edit(product);"
    [ngClass]="product.hasModifiedHighlight ? 'backingHighlight' : ''">
    <div class="pictures-label" [hidden]="!product.HasMultipleImages"><span>+{{baseCardService.getImagesCount(product)}}
            {{getLocalizationString("Pictures","Pictures")}}</span></div>
    <div class="card-img-container text-center">
        <div [ngClass]="product.PointStoreProductAllAssignments.attr.length > 0 ? 'locked-item-overlay' : ''"></div>
        <img cvLocalizedText langSection="MarketPlace_Management" langKey="Image_Not_Available"
            alt="Image Not Available" [ngClass]="product.ProductImageID == 0 ? '' : 'card-img-top-custom'"
            [src]="displayProductImg(product)" />
        <span cvLocalizedText langSection="MarketPlace_Management" langKey="Image_Not_Available" class="text-no-image"
            *ngIf="product.ProductImageID == 0 && !baseCardService.isMainImageEmptyWithMultiplesImages(product)">Image Not Available</span>
    </div>
    <svg *ngIf="product.PointStoreProductAllAssignments.attr.length > 0"
        class="icon-24 fill-white marketplace-locked-item left-icon">
        <use xlink:href=""
            [attr.href]=" product.isLocked ? '../../../App_Themes/clearview-default/icons/utility/lock.svg#lock' : '../../../App_Themes/clearview-default/icons/utility/unlock.svg#unlock' ">
        </use>
    </svg>

    <div class="pointStoreThumbnailCopy" title="{{getLocalizationString('Copy_Product','Copy Product')}}" (click)="copy(product); $event.stopPropagation();"></div>
    <div class="pointStoreThumbnailRemove" title="{{getLocalizationString('Remove_Product','Remove Product')}}" (click)="remove(product); $event.stopPropagation();">
    </div>

    <div class="card-body">
        <h5 class="card-title color-whaleTail lato-bold font-size-16">{{product.Title}}</h5>
        <div class="row">
            <div class="col-6 lato-regular font-size-12 color-valyrianSteel">
                <span cvLocalizedText langSection="MarketPlace_Management" langKey="Category_Colon">Category:</span>
            </div>
            <div class="col-6 lato-regular font-size-12 color-whaleTail text-truncate" title="{{product.Category}}">
                {{product.Category}}
            </div>
        </div>
        <div class="row">
            <div class="col-6 lato-regular font-size-12 color-valyrianSteel">
                <span cvLocalizedText langSection="MarketPlace_Management"
                    langKey="Sub_Category_Colon">Sub-Category:</span>
            </div>
            <div class="col-6 lato-regular font-size-12 color-whaleTail text-truncate" title="{{product.SubCategory}}">
                {{product.SubCategory}}
            </div>
        </div>
        <div class="row">
            <div class="col-6 lato-regular font-size-12 color-valyrianSteel">
                <span cvLocalizedText langSection="MarketPlace_Management"
                langKey="Variations">Variations:</span>
            </div>
            <div class="col-6 lato-regular font-size-12 color-whaleTail text-truncate"
                title="{{product.HasProductVariations == true ? product.VariationsData.length + ' ' + product.VariationName :  (getLocalizationString('None','None'))}}">
                {{product.HasProductVariations == true ? product.VariationsData.length + ' ' + product.VariationName :
                (getLocalizationString('None',"None"))}}
            </div>
        </div>
        <div class="row">
            <div class="col-6 lato-regular font-size-12 color-valyrianSteel">
                <span cvLocalizedText langSection="MarketPlace_Management" langKey="Quantity_Detail">Quantity:</span>
            </div>
            <div class="col-6 lato-regular font-size-12 color-whaleTail">
                {{baseCardService.getProductTotalQuantity(product)}}
                <span
                    [hidden]="!(product.Quantity != null && product.ReservedQuantity != null && !product.HasProductVariations)">
                    = {{product.Quantity + product.ReservedQuantity | number}} <span cvLocalizedText
                        langSection="MarketPlace_Management" langKey="stock">stock</span> - {{product.ReservedQuantity |
                    number}} <span cvLocalizedText langSection="MarketPlace_Management"
                        langKey="carts">cart(s)</span></span>
            </div>
        </div>
        <div class="row">
            <div class="col-6 lato-regular font-size-12 color-valyrianSteel">
                <span cvLocalizedText langSection="MarketPlace_Management" langKey="Total_Ordered">Total Ordered:</span>
            </div>
            <div class="col-6 lato-regular font-size-12 color-whaleTail">
                {{product.QuantityOrdered == null ? '0' : product.QuantityOrdered | number}}
            </div>
        </div>
        <div class="row">
            <div class="col-6 lato-regular font-size-12 color-valyrianSteel">
                <div class="pointStoreThumbnailAssignments" [title]="baseCardService.GetAssignmentTooltip(product)">
                    <span cvLocalizedText langSection="MarketPlace_Management" langKey="Assigned">Assigned</span>
                </div>
            </div>
            <div class="col-6 lato-regular font-size-12 color-whaleTail">
                <div class="pointStoreThumbnailAssignments" [title]="baseCardService.GetAssignmentTooltip(product)">
                <span [hidden]="!getProductAssignment()">
                    <span cvLocalizedText langSection="MarketPlace_Management" langKey="Yes">Yes</span>
                </span>
            </div>
            <div class="pointStoreThumbnailAssignments" [title]="baseCardService.GetAssignmentTooltip(product)">
                <span [hidden]="getProductAssignment()">
                    <span cvLocalizedText langSection="MarketPlace_Management" langKey="No">No</span>
                </span>
            </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12" style="height:21px;">
                <div class="badge badge-carousel mr-1" [title]="getTitle(product, 'carousel')"
                    [hidden]="!(product.CarouselStart != null)"
                    [ngClass]="baseCardService.isActive(product, 'carousel')" cvLocalizedText
                    langSection="MarketPlace_Management" langKey="Carousel">Carousel</div>

                <div class="badge badge-featured mr-1" [title]="getTitle(product, 'featured')"
                    [hidden]="!(product.FeatureStart != null)" [ngClass]="baseCardService.isActive(product, 'featured')"
                    cvLocalizedText langSection="MarketPlace_Management" langKey="Featured">Featured</div>

                <div class="badge badge-sale mr-1" [title]="getTitle(product, 'sale')"
                    [hidden]="!(product.Sale > 0 && product.SaleStart != null)"
                    [ngClass]="baseCardService.isActive(product, 'sale')" cvLocalizedText
                    langSection="MarketPlace_Management" langKey="Sale">Sale</div>

            </div>
            <div class="col-12">
                <p></p>
            </div>
        </div>
        <div class="m-0">
            <div class="d-inline-block color-whaleTail p-0 text-nowrap" style="min-width: 48%;"
                [ngStyle]="product.HasProductVariations && product.HasVariationPrices && getTitle(product, 'variationsPrices').length > 17 ? {'width':'100%'} : {'width':'48%'}">
                <span class="coinIcon mr-1"></span>
                <span [title]="getTitle(product, 'salePrice')"
                    [hidden]="!(baseCardService.showSale(product) && !product.HasProductVariations && !product.HasVariationPrices)">{{computeSalePrice(product)
                    | number}} </span>
                <span [title]="getTitle(product, 'price')"
                    [hidden]="!(!baseCardService.showSale(product) && !product.HasProductVariations && !product.HasVariationPrices)"
                    [ngClass]="baseCardService.showSale(product) ? 'onSale' : ''">{{product.Price | number}}</span>
                <span [title]="getTitle(product, 'price')"
                    [hidden]="!(!baseCardService.showSale(product) && product.HasProductVariations && !product.HasVariationPrices)"
                    [ngClass]="baseCardService.showSale(product) ? 'onSale' : ''">{{product.Price | number}}</span>
                <span [title]="getTitle(product, 'salePrice')"
                    [hidden]="!(baseCardService.showSale(product) && product.HasProductVariations && !product.HasVariationPrices)">{{computeSalePrice(product)
                    | number}} </span>
                <span [title]="getTitle(product, 'variationsPrices')"
                    *ngIf="product.HasProductVariations && product.HasVariationPrices;"
                    [ngClass]="baseCardService.showSale(product) ? 'onSale' : ''">{{calculateInitialVariationPrice(product)
                    | number}} - {{calculateLastVariationPrice(product) | number}}</span>
            </div>
            <div class="d-inline-block p-0 w-50 text-nowrap"
                [ngStyle]="product.HasProductVariations && product.HasVariationPrices && getTitle(product, 'variationsPrices').length > 17 ? {'text-align':'left'} : {'text-align':'right'}">
                <span class="lato-regular font-size-10 color-valyrianSteel">
                    <span>{{product.ProductStart | date : DateFormat}} - {{product.ProductEnd | date :
                        DateFormat}}</span>
                    <span [hidden]="!(product.ProductEnd == null)"><span cvLocalizedText
                            langSection="MarketPlace_Management" langKey="Ongoing">Ongoing</span></span>
                </span>
            </div>
        </div>
    </div>
</div>
